import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { generalGetFunction, generalPostFunction } from "../Globals/globalFunctions";
import { toast } from "react-toastify";
import { SvgIcon } from "../Components/SvgIcons";

function UPIPaymentRequests() {
	const navigate = useNavigate();
	const [allUpiRequests, setAllUpiRequests] = useState([]);

	const getAllUPIPaymentRequests = async () => {
		const response = await generalGetFunction("/getclaimrequest", "3000");

		if (response) {
			setAllUpiRequests(response);
		}
	};

	useEffect(() => {
		getAllUPIPaymentRequests();
	}, []);

	const approveRequest = async (item) => {
		const payload = {
			username: item.username,
		};
		const response = await generalPostFunction(`/paiduser`, payload, "3000");
		if (response) {
			toast.success("Request Approved Successfully!");
			getAllUPIPaymentRequests();
		}
	};

	const denyRequest = async (item) => {
		const payload = {
			username: item.username,
		};
		const response = await generalPostFunction(`/denypayuser`, payload, "3000");
		if (response) {
			toast.success("Request Denied!");
			getAllUPIPaymentRequests();
		}
	};

	return (
		<div className="overviewTableWrapper">
			<div className="overviewTableChild">
				<div className="d-flex flex-wrap">
					<div className="col-12">
						<div className="heading">
							<div className="content">
								<h4>
									UPI Requests{" "}
									<button className="clearButton">
										<SvgIcon name="refresh" />
									</button>
								</h4>
							</div>
							<div className="buttonGroup">
								<button className="panelButton gray" onClick={() => navigate(-1)}>
									<span className="text">Back</span>
									<span className="icon">
										<SvgIcon name="back" />
									</span>
								</button>
								<button className="panelButton" onClick={getAllUPIPaymentRequests}>
									<span className="text">Refresh</span>
									<span className="icon">
										<SvgIcon name="refresh" />
									</span>
								</button>
							</div>
						</div>
					</div>
					<div className="col-12" style={{ overflow: "auto", padding: "10px 20px 0px" }}>
						<div className="tableContainer">
							<table>
								<thead>
									<tr>
										<th>#</th>
										<th>Username</th>
										<th>UPI ID</th>
										<th>Phone</th>
										<th>Balance</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody>
									{allUpiRequests && allUpiRequests.length > 0 ? (
										allUpiRequests.map((item, index) => {
											return (
												<tr>
													<td>{index + 1}</td>
													<td>{item.username}</td>
													<td>{item.upi_id}</td>
													<td>{item.phone}</td>
													<td>{item.balance}</td>
													<td>
														<div className="d-flex justify-content-between">
															<button className="tableButton edit" onClick={() => approveRequest(item)}>
																<SvgIcon name="check" />
															</button>
															<button className="tableButton delete" onClick={() => denyRequest(item)}>
																<SvgIcon name="xmark" />
															</button>
														</div>
													</td>
												</tr>
											);
										})
									) : (
										<tr>
											<td colSpan={99}>No Data Found!</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default UPIPaymentRequests;
